module.exports = __webpack_public_path__ + "static/media/1216.4ba39679.jpg";